import { render, staticRenderFns } from "./Sells.vue?vue&type=template&id=f9198c80&scoped=true&"
import script from "./Sells.vue?vue&type=script&lang=js&"
export * from "./Sells.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9198c80",
  null
  
)

export default component.exports